"use client";

import { OilIcon } from "@/svg/doctor-training/oil-icon";
import { ReactNode } from "react";
import { createPath } from "@/service/routing/routing";
import { RatingCard } from "@/components/doctor-training/rating-card";
import { BriefcaseMedicalIcon, MapPinIcon, UserIcon } from "lucide-react";
import { AnimatedNumber } from "@/components/motion-primitives/animated-number";
import { cn } from "@/lib/utils";

export const CardInternshipDetails = ({
  details,
  facility: { id, slug },
  city,
}: {
  details: MedicalFacilityCardInternshipDetails;
  facility: MedicalFacilityCard;
  city: string;
}) => {
  const { medicalChamber, seats, availableOnSiteTrainings } = details;

  const Detail = ({
    children,
    title = undefined,
    onClick = () => {},
    className = "",
  }: {
    children: ReactNode;
    title?: string;
    onClick?: () => void;
    className?: string;
  }) => (
    <div
      className={cn(
        `@512:justify-center flex items-center justify-start gap-1.5 text-sm text-[#1e1926]`,
        className,
      )}
      data-title={title}
      onClick={onClick}
    >
      {children}
    </div>
  );

  const RatingWrapper = ({ children }: { children: ReactNode }) => (
    <a
      href={createPath("internship_map.facility.report.index", {
        slug: slug,
      })}
      target={"_blank"}
    >
      {children}
    </a>
  );

  return (
    <div className={"@container"}>
      <div
        className={
          "@384:grid-cols-3 @512:flex @512:items-center @512:justify-start mt-2 grid grid-cols-2 gap-8 gap-y-4"
        }
      >
        <Detail>
          <OilIcon />
          {medicalChamber.shortcut}
        </Detail>
        <Detail>
          <MapPinIcon size={"16px"} /> {city}
        </Detail>
        <Detail title={"Liczba wolnych miejsc stażowych"}>
          <UserIcon size={"16px"} />{" "}
          <span className={"w-[20px]"}>
            {seats === null ? "b.d." : <AnimatedNumber value={seats} />}
          </span>
        </Detail>
        <Detail title={"Liczba staży cząstkowych na miejscu"}>
          <BriefcaseMedicalIcon size={"16px"} />
          {availableOnSiteTrainings.length === 0 ? (
            "b.d."
          ) : (
            <span>
              <AnimatedNumber value={availableOnSiteTrainings.length} />
              /9
            </span>
          )}
        </Detail>{" "}
        <Detail
          title={"Liczba staży cząstkowych na miejscu"}
          className={"w-[80px]"}
        >
          {details.rating.count > 0 ? (
            <RatingWrapper>
              <RatingCard rating={details.rating} />
            </RatingWrapper>
          ) : (
            <RatingCard rating={details.rating} />
          )}
        </Detail>
      </div>
    </div>
  );
};
